import { useState, useContext } from "react";

// Styles
import styled from "styled-components";

// Components
import AddReview from "../addReview";

// Globals
import { black, orange, pale } from "../../globals";

// Context
import { ReviewContext } from "../../contexts/ReviewContext";
import Alert from "../alert";

const Testimonials = () => {
  const [selected, setSelected] = useState(0);

  const { reviews } = useContext(ReviewContext);

  const [show, setShow] = useState(false);

  const handleChange = (key) => {
    setSelected(key);
  };

  const handleClick = () => {
    setShow(!show);
  };

  return (
    <Wrapper id="testimonials">
      <Title>Happy Customers</Title>
      <Row>
        {reviews.reviews.map(
          (review, i) =>
            review.accepted && (
              <Section
                key={review._id}
                selected={selected === i}
                onMouseOver={() => handleChange(i)}
              >
                <Name>{review.name}</Name>
                <Message>{review.message}</Message>
              </Section>
            )
        )}
      </Row>
      <Add onClick={handleClick}>{show ? "Cancel Review" : "Add Review"}</Add>
      <Alert />
      {show && <AddReview handleClick={handleClick} />}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 56px 14px;
  align-items: center;
  background-color: ${pale};
`;

const Title = styled.h2`
  text-align: center;
  color: ${black};
  margin: 8px 0px 28px;
`;

const Name = styled.h4`
  text-align: center;
  margin: 0;
  padding: 16px 14px 8px;
  font-size: 1.05em;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  background-color: white;
  border-radius: 10px;
  border: 1px solid #e4e4e4;
  cursor: pointer;
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.12);
  opacity: ${(p) => (p.selected ? "1" : "0.8")};
  transition: opacity 0.25s ease-in-out, transform 0.25s ease-in-out,
    box-shadow 0.25s ease-in-out;
  min-height: 220px;
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.16);
    opacity: 1;
  }
  @media (max-width: 1200px) {
    opacity: 1;
    &:hover {
      transform: none;
    }
  }
`;

const Message = styled.p`
  padding: 0px 16px 18px;
  text-align: center;
  line-height: 1.55;
  color: #2f2f2f;
`;

const Add = styled.button`
  border: none;
  font-size: 1.2em;
  background: none;
  margin: 20px 0px;
  cursor: pointer;
  color: ${black};
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  padding: 10px 20px;
  &:hover {
    background-color: ${orange};
    color: white;
  }
`;

export default Testimonials;
